import { gql } from "@apollo/client";

export default gql`
  mutation deleteTestConversation($data: DeleteTestConversationInput){
    deleteTestConversation(data: $data){
        success
        data
        code
        message
    }
}
`
